var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgToastInfo = function SvgToastInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "toast_info_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#toast_info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.908 13.26h1.187V8.708H8.908zM9.5 7.353a.62.62 0 0 0 .456-.184.62.62 0 0 0 .184-.455.62.62 0 0 0-.184-.456.62.62 0 0 0-.456-.184.62.62 0 0 0-.455.184.62.62 0 0 0-.184.456q0 .271.184.455a.62.62 0 0 0 .455.184m.002 9.668a7.3 7.3 0 0 1-2.934-.593 7.6 7.6 0 0 1-2.388-1.607 7.6 7.6 0 0 1-1.608-2.387A7.3 7.3 0 0 1 1.98 9.5q0-1.56.593-2.933A7.6 7.6 0 0 1 4.18 4.179a7.6 7.6 0 0 1 2.387-1.608A7.3 7.3 0 0 1 9.5 1.98q1.56 0 2.933.592t2.389 1.607a7.6 7.6 0 0 1 1.608 2.388 7.3 7.3 0 0 1 .592 2.932q0 1.56-.592 2.934a7.6 7.6 0 0 1-1.607 2.388 7.6 7.6 0 0 1-2.388 1.608 7.3 7.3 0 0 1-2.932.593M9.5 15.833q2.652 0 4.493-1.84 1.84-1.841 1.84-4.493t-1.84-4.493q-1.84-1.84-4.493-1.84-2.652 0-4.492 1.84T3.168 9.5t1.84 4.493q1.842 1.84 4.493 1.84"
  }))));
};
export default SvgToastInfo;